import {ReactElement, useState} from "react"
import {Create} from "@refinedev/antd"
import {Col, Form, FormListFieldData, InputNumber, Row, Select, TimePicker} from "antd"
import {Input} from "antd/lib"
import TextArea from "antd/es/input/TextArea"
import IClient from "../../interfaces/IClient"
import {createActivity} from "../../services/ServiceActivity"
import {getClients} from "../../services/ServiceClient"
import {getAuthentications} from "../../services/ServiceAuthentication"
import {getTypes} from "../../services/ServiceType"
import {Custom} from "../../utils/refineUtils"
import ClientCard from "../../components/cards/ClientCard"
import InstanceCard from "../../components/cards/InstanceCard"
import {useTranslate} from "@refinedev/core"
//@ts-ignore
import {v4 as uuidv4} from 'uuid'


export default function ActivityCreate(): ReactElement | null {
    const translate = useTranslate()
    const [clientsSelected, setClientsSelected] = useState<string[]>([])
    const {saveButtonProps, formProps, loadingForm} = createActivity()
    const {clients, isClientsLoading} = getClients()
    const {authentications, isAuthenticationsLoading} = getAuthentications()
    const {types, isTypesLoading} = getTypes()
    const toggleClient = (client: IClient): void => {
        setClientsSelected(clientsSelected.includes(client.id) ? clientsSelected.filter(cl => cl !== client.id) : clientsSelected.concat(client.id));
    }
    const handleOnFinish = (values: any) => {
        values?.instances?.forEach((instance: any) => instance.id = uuidv4())
        values.clients = values?.clients.filter((client: any) => client)
        formProps.onFinish && formProps.onFinish(values);
    }

    return <Create title={translate("activity.meta.new")}
                   saveButtonProps={{...saveButtonProps, children: translate('buttons.create')}}
                   isLoading={loadingForm || isClientsLoading || isAuthenticationsLoading || isTypesLoading}>
        <Form labelWrap layout="horizontal" labelAlign="left" {...formProps} onFinish={handleOnFinish}>
            <Row gutter={16}>
                <Col span={12}>
                    <Custom.Item name="title" label="activity.title" icon="notification" required>
                        <Input/>
                    </Custom.Item>
                    <Custom.Item name="author" label="activity.author" icon="user" required>
                        <Input/>
                    </Custom.Item>
                    <Custom.Item name="description" label="activity.description" icon="align-left">
                        <TextArea rows={4}/>
                    </Custom.Item>
                    <Custom.Item name="duration" label="activity.duration" icon="clock-circle">
                        <InputNumber min={0} style={{width: '100%'}}/>
                        {/*<TimePicker style={{width: '100%'}} showNow={false} format="HH:mm"/>*/}
                    </Custom.Item>
                    <Custom.Item name="url" label="activity.url" icon="link" required>
                        <Input/>
                    </Custom.Item>
                </Col>
                <Col span={12}>
                    <Custom.Item name="authentications" label="activity.authentications" icon="login" required>
                        <Select allowClear mode="multiple"
                                options={authentications?.map(auth => ({label: auth.name, value: auth.id}))}
                                tagRender={(props) => {
                                    const auth = authentications.find(a => a.id === props.value)
                                    const type = types.find(t => t.id === auth?.type)
                                    return <Custom.Tag {...props} auth={auth} type={type}/>
                                }}/>
                    </Custom.Item>
                    <Custom.List name="clients" label="activity.clients" icon="crown" required>
                        {clients?.map((client: IClient, index) => (
                            <ClientCard editable index={index} key={client.id} client={client} form={formProps?.form}
                                        checked={clientsSelected.includes(client.id)} onChange={toggleClient}/>
                        ))}
                    </Custom.List>
                </Col>
            </Row>
            <Col>
                <Custom.List name="instances" label="activity.instances" icon="calendar" editable>
                    {(formList: FormListFieldData[], remove: (index: number | number[]) => void) =>
                        formList.map(({key, name: index}) => (
                            <InstanceCard key={key} editable index={index} onDelete={remove}/>))}
                </Custom.List>
            </Col>
        </Form>
    </Create>
}